export interface SchemaPlayerCanvas {
    addOverlay(): HTMLDivElement

    addUnderlay(): HTMLDivElement

    hidePopover(): void

    getPositionRect(id: number): DOMRect | null;
}

let instance: SchemaPlayerCanvas | null = null;

export function setCurrentSchemaPlayerCanvas(canvas: SchemaPlayerCanvas | null) {
    instance = canvas;
}

export function getCurrentSchemaPlayerCanvas(): SchemaPlayerCanvas | null {
    return instance;
}
